module.exports = __webpack_public_path__ + "img/suzuki-jimny-3.cbaafd3f.8c87bb6f.jpg";